
const PatternUtils = {
    celular : /[^0-9()\s-]/g
}

export { PatternUtils };

